import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AWS_API_HELPERS } from '../../utils/variables';
import InlineSVG from 'react-inlinesvg';
import Axios from 'axios';
import badge from './badge-remove.svg';
import photoIcon from './picture.svg';
import { FormattedMessage } from 'react-intl';

/*global XDomainRequest*/
/**
 * component that uploads user selected file to S3 bucket and returns file URL
 */
export default class PhotoUploader extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            progress: 0,
            creatingThumb: false
        };
    }

    getSignedUrl(filetype) {
        return Axios.get(`${AWS_API_HELPERS}/userupload?filetype=${filetype}`);
    }

    uploadImage(blob, filetype, s3url) {
        return new Promise((resolve, reject) => {
            const xhr = this.createCORSRequest('PUT', s3url);

            xhr.onload = () => {
                if (xhr.status === 200) {
                    console.log(xhr.status);

                    resolve();
                } else {
                    console.log(xhr.status);

                    reject(xhr.status);
                }
            };

            xhr.onerror = () => {
                reject();
            };

            xhr.upload.onprogress = this.handleProgress;

            xhr.setRequestHeader('Content-Type', filetype);
            xhr.setRequestHeader('x-amz-acl', 'public-read');
            return xhr.send(blob);
        });
    }

    handleProgress = e => {
        const state = Math.round((e.loaded / e.total) * 100);
        this.setState({ progress: state });
    };

    createCORSRequest(method, url) {
        let xhr = new XMLHttpRequest();

        if (xhr.withCredentials !== null) {
            xhr.open(method, url, true);
        } else if (typeof XDomainRequest !== 'undefined') {
            xhr = new XDomainRequest();
            xhr.open(method, url);
        } else {
            xhr = null;
        }

        return xhr;
    }
    handleImageUpload = e => {
        this.setState({ loading: true });
        const file = e.target.files[0];
        console.log(file.type);

        if (file.type.indexOf('image') === -1) {
            alert(
                'Abychom dokázali fotku vytisknout, potřebujeme ji mít ve formátu jpg nebo png. \n \n Pokud ji v tomto formátu nemáte, napište nám po odeslání objednávky na email. My vám s tím rádi pomůžeme 😉'
            );
            this.setState({ loading: false });
            return;
        }

        this.getSignedUrl(file.type)
            .then(res => {
                const urlData = res.data;
                console.log(urlData);
                this.uploadImage(file, file.type, urlData.url)
                    .then(res => {
                        this.props.onPhotoUploaded(urlData.filename);
                        this.setState({ loading: false });
                    })
                    .catch(this.handleUploadError);
            })
            .catch(this.handleUploadError);
    };

    handleUploadError = e => {
        console.log(e);
        alert(
            'Nepodařilo se nahrát obrázek. Zkuste prosím nahnrání opakovat a  pokud se to znovu nepovede, pošlete nám obrázek emailem.'
        );
        this.setState({ loading: false });
    };

    handleRemoveClick = e => {
        e.preventDefault();
        this.props.onPhotoUploaded(null);
    };

    render() {
        if (this.props.uploadedPhoto) {
            const url = `https://darkovakrabicka-uploads.imgix.net/${
                this.props.uploadedPhoto
            }?h=42`;
            const url2x = `https://darkovakrabicka-uploads.imgix.net/${
                this.props.uploadedPhoto
            }?h=42&dpr=2  2x`;
            return (
                <div className="photo-uploader-image">
                    <button className="btn-badge-remove" onClick={this.handleRemoveClick}>
                        <InlineSVG src={badge} />
                    </button>
                    <img src={url} srcSet={url2x} alt="" />
                </div>
            );
        }

        if (this.state.loading) {
            return (
                <div className="btn btn-editor">
                    <FormattedMessage defaultMessage="Nahrávám" id={'photoUploader.progress'} />{' '}
                    {this.state.progress}%
                </div>
            );
        }

        return (
            <form className="btn-file-wrapper photo-uploader">
                <span className="btn btn-editor">
                    <InlineSVG src={photoIcon} />
                    <FormattedMessage defaultMessage="přidat fotku" id={'photoUploader.add'} />
                </span>
                <input type="file" onChange={this.handleImageUpload} />
            </form>
        );
    }
}

PhotoUploader.propTypes = {
    uploadedPhoto: PropTypes.string,
    onPhotoUploaded: PropTypes.func
};
